/**
 * Reusable Dashboard Grid Component
 * Responsive grid layout for dashboard stat cards
 */

import React from 'react';
import { SPACING, BREAKPOINTS } from '../../constants/theme';

export interface DashboardGridProps {
  children: React.ReactNode;
  columns?: 2 | 3 | 4;
}

export const DashboardGrid: React.FC<DashboardGridProps> = ({ children, columns = 3 }) => {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: `repeat(${columns}, 1fr)`,
        gap: SPACING.xl,
      }}
      className="dashboard-grid"
    >
      {children}

      <style>{`
        @media (max-width: ${BREAKPOINTS.desktop}) {
          .dashboard-grid {
            grid-template-columns: repeat(2, 1fr) !important;
          }
        }

        @media (max-width: ${BREAKPOINTS.tablet}) {
          .dashboard-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </div>
  );
};
